import React, { Component } from 'react';
import { Field } from 'redux-form';
import FormField from '../form-field';

class PasswordField extends Component {
  constructor(props) {
    super(props);

    this.onPasswordChange = this.onPasswordChange.bind(this);
  }

  onPasswordChange(ev) {
    this.props.onPasswordChange(ev.target.value);
  }

  render() {
    return (
      <Field
        name="password"
        type="password"
        component={FormField}
        label={this.props.label}
        onChange={this.onPasswordChange}
      />
    );
  }
}

PasswordField.defaultProps = {
  label: 'Password',
  onPasswordChange: () => { alert('onPasswordChange callback not implemented'); },
};

export default PasswordField;



// WEBPACK FOOTER //
// ./src/desktop/components/signin/password-field.js